import { EventDTO, EventPostGuest, EventRequestDTO, GuestEventPost, JoinEventGuest } from "../../dtos/guest";
import { FAKE_EVENTS, fakeDelay } from "../../fake";
import { type IGuestApi } from "./IGuestApi";

/** Fixture-backed IGuestApi for `yarn start:fake`; see FAKE_EVENTS for the event keys. */
export class FakeGuestApi implements IGuestApi {

    public async event(dto: EventRequestDTO): Promise<EventDTO> {
        await fakeDelay();
        const event = FAKE_EVENTS[dto.event];
        if(!event) throw new Error(`No fake event "${dto.event}". Try: ${Object.keys(FAKE_EVENTS).join(', ')}`);
        return event;
    }

    public async joinEvent(payload: {name: string, moment: string}): Promise<JoinEventGuest> {
        await fakeDelay();
        return {
            message: 'Joined (fake)',
            access_token: 'fake-token',
            moment_id: payload.moment,
            user: {
                id: 'fake-guest',
                name: payload.name,
                email: '',
                media: '',
                avatar: '',
            },
        };
    }

    public async post(payload: GuestEventPost): Promise<EventPostGuest> {
        await fakeDelay(1000);
        const now = new Date().toISOString();
        return {
            message: 'Posted (fake)',
            data: {
                moment_id: payload.moment,
                user_id: 'fake-guest',
                content: payload.content ?? '',
                only_attendees: payload.only_attendees,
                id: `fake-post-${Date.now()}`,
                updated_at: now,
                created_at: now,
            },
        };
    }
}
